import Metadata from '@/core/components/metadata/Metadata'
import { useNavigate } from 'react-router-dom'
import { frontPaths } from '@/config/frontPaths.ts'
import { Button } from '@mui/material'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <>
      <Metadata>
        <title>Página no encontrada</title>
      </Metadata>
      <p>La página visitada no existe</p>
      <h2>404</h2>
      <Button onClick={() => navigate(frontPaths.home)}>
        Volver a la página inicial
      </Button>
    </>
  )
}

export default NotFoundPage
